import { useState } from 'react';
import { FilterSection, FilterFooter } from '@hakimo-ui/hakimo/ui-filters';
import {
  PersonProfileFilters,
  DEFAULT_PERSON_PROFILE_FILTERS,
  ProfileTypeFilterValue,
  EmployeeIdFilterValue,
  BadgeIdFilterValue,
  StatusFilterValue,
} from '../types';
import { ProfileTypeFilter, EmployeeIdFilter, StatusFilter } from './index';

interface Props {
  filters: PersonProfileFilters;
  onApplyFilters: (filters: PersonProfileFilters) => void;
  showBadgeId?: boolean;
}

function FilterPanelContent(props: Props) {
  const { filters, onApplyFilters, showBadgeId = false } = props;
  const [localFilters, setLocalFilters] = useState<PersonProfileFilters>(
    filters || DEFAULT_PERSON_PROFILE_FILTERS
  );

  const onApplyFiltersCb = () => {
    onApplyFilters(localFilters);
  };

  const onResetFilters = () => {
    setLocalFilters(DEFAULT_PERSON_PROFILE_FILTERS);
  };

  const onChangeProfileType = (profileType: ProfileTypeFilterValue) => {
    setLocalFilters((prev) => ({
      ...prev,
      profileType,
    }));
  };

  const onChangeEmployeeId = (employeeId: EmployeeIdFilterValue) => {
    setLocalFilters((prev) => ({
      ...prev,
      employeeId,
    }));
  };

  const onChangeBadgeId = (badgeId: BadgeIdFilterValue) => {
    setLocalFilters((prev) => ({
      ...prev,
      badgeId,
    }));
  };

  const onChangeStatus = (status: StatusFilterValue) => {
    setLocalFilters((prev) => ({
      ...prev,
      status,
    }));
  };

  return (
    <div className="space-y-6">
      <div className="dark:divide-dark-border-bg dark:border-dark-border-bg divide-y border-b border-t">
        <FilterSection
          title="Profile Type"
          content={
            <ProfileTypeFilter
              value={localFilters.profileType}
              onChange={onChangeProfileType}
            />
          }
          hasFilterApplied={localFilters.profileType?.value !== undefined}
        />
        <FilterSection
          title={showBadgeId ? 'Badge ID' : 'Employee ID'}
          content={
            showBadgeId ? (
              <EmployeeIdFilter
                value={localFilters.badgeId}
                onChange={onChangeBadgeId}
                placeholder="Enter badge ID..."
              />
            ) : (
              <EmployeeIdFilter
                value={localFilters.employeeId}
                onChange={onChangeEmployeeId}
                placeholder="Enter employee ID..."
              />
            )
          }
          hasFilterApplied={
            showBadgeId
              ? !!(
                  localFilters.badgeId?.value &&
                  localFilters.badgeId.value.length > 0
                )
              : !!(
                  localFilters.employeeId?.value &&
                  localFilters.employeeId.value.length > 0
                )
          }
        />
        <FilterSection
          title="Status"
          content={
            <StatusFilter
              value={localFilters.status}
              onChange={onChangeStatus}
            />
          }
          hasFilterApplied={localFilters.status?.isEnabled !== undefined}
        />
      </div>
      <FilterFooter
        onApply={onApplyFiltersCb}
        onReset={onResetFilters}
        trackingEventNameApply="apply_users_filters"
        trackingEventNameReset="reset_users_filters"
      />
    </div>
  );
}

export default FilterPanelContent;
